import Edit from './edit';
import View from './view';

export default {
  Edit,
  View,
};
